import { render, staticRenderFns } from "./PopHorario.vue?vue&type=template&id=f48a3178&scoped=true"
import script from "./PopHorario.vue?vue&type=script&lang=js"
export * from "./PopHorario.vue?vue&type=script&lang=js"
import style0 from "./PopHorario.vue?vue&type=style&index=0&id=f48a3178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48a3178",
  null
  
)

export default component.exports